module.exports = __webpack_public_path__ + "img/合照.8cece295.jpg";